module.exports = __webpack_public_path__ + "img/banner.7ad9504.png";